import { render, staticRenderFns } from "./CloSkipTo.vue?vue&type=template&id=36e64150&"
import script from "./CloSkipTo.vue?vue&type=script&lang=js&"
export * from "./CloSkipTo.vue?vue&type=script&lang=js&"
import style0 from "./CloSkipTo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports